export default __webpack_public_path__ + "files/64.1f092ae5131a49cf2c297937055712f9.png";